<nb-card *ngIf="searchValue.length>1" class="searchResContainer">
  <nb-card-header *ngIf="(custDatas$ | async) as custDatas">
    Search Results: ({{custDatas['docs']?custDatas['docs'].length:0}})
    <a (click)="clearSearchInput()"> Clear </a>
  </nb-card-header>
  <nb-card-body fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="32px"
    fxLayoutAlign="flex-start"
    *ngIf="(custDatas$ | async) as custDatas">
    <mat-card *ngFor="let item of custDatas.docs" fxFlex="0 1 calc(33.3% -
      32px)" fxFlex.lt-md="0 1 calc(50% - 32px)"
      fxFlex.lt-sm="100%" class="searchResCard mat-elevation-z8">
      <a [routerLink]="['/user', item._id]" [state]="{ data: item}"
        style="text-decoration: none;">
        <mat-card-content>
          <nb-user size="large" name="{{item['fullName']}}"
            title="{{item['emailId']?item['emailId']:item['mobile']}}"
            [picture]="item['profilePicUrl']" color="#ffc94d"
            showInitials="true">
          </nb-user>
        </mat-card-content>
        <mat-card-footer class="hubStatus">
          <span *ngFor="let hub of item.hubs">
            <span *ngIf="hub.isOnline">
              <img src="../../../images/green_new_dot.png" alt="" srcset="">
            </span>
            <span *ngIf="!hub.isOnline">
              <img src="../../../images/red_new_dot.png" alt="" srcset="">
            </span>
          </span>
        </mat-card-footer>
      </a>
    </mat-card>
  </nb-card-body>
</nb-card>
<div *ngIf="(custDatas$ | async) as custDatas">
  <nb-card *ngIf="custDatas.additionalDetails.blackListedHubs.length> 0">
    <nb-card-header fxLayout="row wrap">
      <span class="cardInfoText"><h5>Additional Details</h5></span><br>
    </nb-card-header>
    <nb-card-body>
      <span><h6>Blacklisted Hubs</h6></span><br>
      <div fxLayout="row wrap">
        <mat-card *ngFor="let item of
          custDatas.additionalDetails.blackListedHubs" 
          fxFlex="0 1 calc(70% - 32px)" 
          fxFlex.lt-md="0 1 calc(50% - 32px)"
          fxFlex.lt-sm="100%" 
          class="blacklisted searchResCard mat-elevation-z8">
          <mat-card-content>
            <div class="hub-profile">
              <div class="initials">
                eGlu
              </div>
              <div class="name">
                  <span class="hubId">{{item.hubId}}</span><br>
                  <span class="date">BlacktListed Time : {{item.capturedAt | date:'medium'}}</span><br>
                  <span class="title" *ngIf="item.deblackListReason">De-BlackList Reason : {{item.deblackListReason}}</span><br>
                  <span class="title" *ngIf="item.deblackListedAt">De-BlackList Time : {{item.deblackListedAt | date:'medium'}}</span><br>
                  <span class="title" *ngIf="item.deblackListedBy">De-BlackList By : {{item.deblackListedBy}}</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </nb-card-body>
  </nb-card>
  <nb-card *ngIf="custDatas.additionalDetails.blackListedNodes.length> 0">
    <nb-card-header fxLayout="row wrap">
      <span class="cardInfoText"><h5>Additional Details</h5></span><br>
    </nb-card-header>
    <nb-card-body>
      <span><h6>Blacklisted Nodes</h6></span><br>
      <div fxLayout="row wrap">
        <mat-card *ngFor="let item of
          custDatas.additionalDetails.blackListedNodes" 
          fxFlex="0 1 calc(70% - 32px)" 
          fxFlex.lt-md="0 1 calc(50% - 32px)"
          fxFlex.lt-sm="100%" 
          class="blacklisted searchResCard mat-elevation-z8">
          <mat-card-content>
            <div class="hub-profile">
              <div class="initials">
                eGlu
              </div>
              <div class="name">
                <span class="hubId">{{item.nodeId}}</span><br>
                <div>
                  <span class="title">Reason : {{item.reason}}</span><br>
                  <span class="title">HUB ID : {{item.hubId}}</span><br>
                  <span class="title">Customer Contact : {{item.ownerContactInfo}}</span><br>
                  <span class="title">Removed By : {{item.invokerEmailId}}</span><br>
                  <span class="date">Time : {{item.invokedAt | date:'medium'}}</span>
                </div>
                <div *ngIf="item.deblackListReason">
                  <br>
                  <span class="title">De-BlackList Reason : {{item.deblackListReason}}</span><br>
                  <span class="title">De-BlackList Time : {{item.deblackListedAt | date:'medium'}}</span><br>
                  <span class="title">De-BlackList By : {{item.deblackListedBy}}</span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </nb-card-body>
  </nb-card>
</div>